const isObject = (val: unknown) => {
  if (val === null) return false;
  return typeof val === 'function' || typeof val === 'object';
};

const objectToString = (
  obj: Record<string, string>,
  propertySeparator: string,
  pairSeparator: string
) => {
  let text = '';
  Object.entries(obj).forEach(([key, value]) => {
    text += `${propertySeparator + key + pairSeparator + value}`;
    return text;
  });
  return text;
};

const stringToObject = (
  text: string,
  propertySeparator: string,
  pairSeparator: string
) => {
  const splitValues = text.split(propertySeparator).filter((value) => value);
  const pairs = splitValues.map((pair) => pair.split(pairSeparator));
  return Object.fromEntries(pairs);
};

const encryptSensitiveUserInfo = (obj: Record<string, string>) => {
  Object.keys(obj).forEach((key) => {
    if (key.match(/email/i) || key.match(/phone/i) || key.match(/mobile/i)) {
      const data = obj[key] || '';
      obj[`encrypted_${key}`] = encryptToHex(data);
      return;
    }
  });
  return obj;
};

const deleteSensitiveUserInfo = (obj: Record<string, string>) => {
  Object.keys(obj).forEach((key) => {
    if (
      (!key.includes('encrypted') && key.match(/email/i)) ||
      key.match(/phone/i) ||
      key.match(/mobile/i)
    ) {
      delete obj[key];
      return;
    }
  });
  return obj;
};

const encryptToHex = (wordToEncrypt: string) => {
  const encryptedWord = wordToEncrypt
    .split('')
    .map((word: string) => word.charCodeAt(0).toString(16))
    .join('');
  return encryptedWord;
};

const toLowerKeys = (obj: Record<string, unknown>) => {
  return Object.keys(obj).reduce<Record<string, unknown>>(
    (accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    },
    {}
  );
};

export {
  deleteSensitiveUserInfo,
  encryptSensitiveUserInfo,
  isObject,
  objectToString,
  stringToObject,
  toLowerKeys,
};
